export function initUITracking() {
  const url = new URL(window.location.href);
  const path = url.pathname;
  const firstSegment = url.pathname.split('/')[1] || '';
  const [lang, country] = firstSegment.split('-');

  // Find all elements with data-tracking-label attribute
  const trackableElements = document.querySelectorAll('[data-tracking-label]');

  trackableElements.forEach((element) => {
    element.addEventListener('click', (e) => {
      const dataLayer = window['dataLayer'];
      if (!dataLayer) {
        return;
      }

      const label = element.getAttribute('data-tracking-label');
      const action = element.getAttribute('data-tracking-action') || 'open';
      const category = element.getAttribute('data-tracking-category') || undefined;

      dataLayer.push({
        'event': 'interaction',
        'action': action,
        'label': label,
        'category': category,
        'component': 'interaction',
        'position': path,
        'language': lang,
        '_clear': true
      });
    });
  });
}
